import * as React from 'react'

import { Truck } from 'lucide-react'
import { observer } from 'mobx-react'

import DeliveryActionTypes from '~/client/src/desktop/enums/DeliveryActionTypes'
import DesktopDeliveryViewStore from '~/client/src/desktop/views/Deliveries/DesktopDeliveryView.store'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import DeliveryGroupingOptions from '../DeliveryGroupingOptions/DeliveryGroupingOptions'

import './DeliveriesMapActionBar.scss'

// localization: translated

interface IProps {
  onNewDeliveryCreate: () => void
  setActionType: (actionType: DeliveryActionTypes) => void
  completedToTotalCountLabel: string
  desktopDeliveryViewStore: DesktopDeliveryViewStore
  onGropingChanged: () => any
  shouldForceCloseGroupingOptions: boolean
  onShowGroupingOptionsChanged: (isShown: boolean) => void
}

@observer
export default class DeliveriesMapActionBar extends React.Component<IProps> {
  public render() {
    const {
      onGropingChanged,
      onNewDeliveryCreate,
      desktopDeliveryViewStore,
      completedToTotalCountLabel,
      onShowGroupingOptionsChanged,
      shouldForceCloseGroupingOptions,
    } = this.props

    return (
      <div className="row bt-light-cool-grey deliveries-map-action-bar no-outline-container px24 absolute full-width">
        <div className="row no-grow br-light-cool-grey sidebar full-height">
          <DeliveryGroupingOptions
            onChanged={onGropingChanged}
            CustomHandleButton={Button}
            onShowChanged={onShowGroupingOptionsChanged}
            forceClose={shouldForceCloseGroupingOptions}
            desktopDeliveryViewStore={desktopDeliveryViewStore}
            shouldHideBandCreation={true}
          />
          <div
            className="text right ellipsis ml4 mr10"
            title={`${Localization.translator.completedTotal} ${completedToTotalCountLabel}`}
          >
            <span className="text large light mr5">
              {Localization.translator.completedTotal}
            </span>
            <span className="text bold">{completedToTotalCountLabel}</span>
          </div>
        </div>
        <div className="row x-end full-height">
          <div className="absolute new-delivery-btn">
            <Button variant="default" onClick={() => onNewDeliveryCreate()}>
              <Truck data-icon="inline-start" />
              {Localization.translator.newDelivery}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
